import { render, staticRenderFns } from "./PermPlacements.vue?vue&type=template&id=0e4f4698&scoped=true&"
import script from "./PermPlacements.vue?vue&type=script&lang=js&"
export * from "./PermPlacements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4f4698",
  null
  
)

export default component.exports